export const CDN_URL = 'https://d1fhe868ipux7g.cloudfront.net';

// npm run start sets NODE_ENV to 'development'; npm run build sets it to 'production'
const IS_LOCAL = process.env.NODE_ENV === 'development';

// The Parki API: the local php -S server (port 8080) under npm run start, api.parki.cloud in a build
let apiBaseUrl = 'https://api.parki.cloud';
if (IS_LOCAL) {
  // apiBaseUrl = 'http://localhost:8080';
}
export const API_URL = `${apiBaseUrl}/base-app`;
export const INTEGRATIONS_API_URL = `${apiBaseUrl}/integrations`;
export const PARKI_WEBSITE = 'https://parki.cloud/';
// export const PARKI_WEBSITE = 'http://localhost/BDO/Parki/parki-website';
// export const PARKI_WEBSITE = 'https://staging.parki.cloud/';

// Folder of the provider logos used by the Integrations Register (copied from the theme's img/orgs)
export const INTEGRATIONS_LOGO_PATH = `${process.env.PUBLIC_URL}/img/integrations`;
